<template>
	<div>
		<v-alert type="warning" :icon="mdiAlertCircle">
			Keine Berechtigung auf {{url}}
		</v-alert>
		<v-btn @click="goBack" class="primary">
      <v-icon left>
        {{mdiChevronLeft}}
      </v-icon>
      Zurück
    </v-btn>
	</div>
</template>

<script>
	import {mdiAlertCircle, mdiChevronLeft} from "@mdi/js";

	export default {
		name: "NoPermission",
		data: () => ({
			mdiAlertCircle, mdiChevronLeft
		}),
		computed: {
			url() {
				return this.$route.query.url;
			}
		},
		methods: {
			goBack() {
				this.$router.go(-1);
			}
		}
	}
</script>

<style scoped>

</style>